import { CustomDropDown } from "./CustomDropDown";
import { CustomPagination } from "./CustomPagination";
import { PageResult } from "./PageResult";
import { ProductCard } from "./ProductCard";
import { SliderVerification } from "./SliderVerification";
import { Numeric } from "./Numeric";
import { CustomUpload } from "./CustomUpload";
import { PayCard } from "./PayCard";
import { ImageCard } from "./ImageCard";

export {
  CustomPagination,
  PageResult,
  ProductCard,
  SliderVerification,
  CustomDropDown as CusDropDown,
  Numeric,
  CustomUpload,
  PayCard,
  ImageCard
};
